import React, { Component } from 'react';
import { Button, Container, Row, Col, Collapse, Form, Table } from 'react-bootstrap';
import config from '../config';
//import {Alert} from 'react-bootstrap';
//import {Toast} from 'react-bootstrap';

class Confirmacion extends Component {
  constructor(props) {
    super(props);
    this.state = {
      msg: "",
      exiteFact: false,
      isRejected: false,
      isAccepted: false,
      causa: "",
      cabeceramsg: "",
      data: {}
    }
  }
  componentDidMount() {
    const { search } = this.props.location;
    const link = search.replace('?', '');
    const datasend = {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      }
    }
    fetch(config.servBackEnd + '/documents/confirm/' + link, datasend)
      .then(response => response.json())
      .then(data => {
        //const datos = data.data;
        if (data.ok) {
          const cdata = data.data[0];
          const msgCab = `Bienvenido ${cdata.NOMBRE_CLIENTE}`
          // const mensaje = `Por favor indique si acepta o rechaza la factura No ${cdata.TIPO_DOCUMENTO} - ${cdata.NUMERO_DOCUMENTO}`;
          this.setState({
            // msg: mensaje,
            exiteFact: true,
            cabeceramsg: msgCab,
            data: cdata
          })
        } else {
          this.setState({
            msg: "LINK INVALIDO, FECHA DE CONFIRMACION CADUCADA O FACTURA YA PROCESADA",
            exiteFact: false,
            cabeceramsg: "IMPORTANTE:"
          })
        }
      });
  }

  confirmar = ({ target }) => {
    const { search } = this.props.location;
    const link = search.replace('?', '');
    let cEstado = 0;
    let cObservacion = "";
    if (target.id === "aceptar") {
      cEstado = 1;
      cObservacion = "APROBADO POR CLIENTE"
    }
    if (target.id === "rechazar") {
      cEstado = 3;
      cObservacion = this.state.causa;
    }


    const datasend = {
      method: 'POST',
      body: JSON.stringify({
        estado: cEstado,
        observacion: cObservacion,
        id: link
      }),
      headers: {
        'Content-Type': 'application/json',
      }
    }
    fetch(config.servBackEnd + '/documents/confirm/update', datasend)
      .then(response => response.json())
      .then(data => {
        //const datos = data.data;
        ////console.log(data);
        if (data.ok) {
          this.setState({
            msg: "FACTURA PROCESADA CORRECTAMENTE",
            exiteFact: false,
            cabeceramsg: "IMPORTANTE:"
          })
        } else {
          this.setState({
            msg: "ERROR EN EL PROCESO, INTENTE MAS TARDE",
            exiteFact: false,
            cabeceramsg: "IMPORTANTE:"
          })
        }
      });
  }

  render() {
    const { data } = this.state
    return (
      <div className="principalconfirmacion">
        <div className="divconfirmacion">
          <Container>
            <Row className="justify-content-md-center">
              <Col md="auto">
                <h3>ACUSE DE RECIBIDO</h3>
              </Col>
            </Row>
            <Row>
              <Col>
                <h4 >
                  {this.state.cabeceramsg}
                </h4>
              </Col>
            </Row>
            <Row>
              <Col>
                <Table striped bordered hover >
                  <tbody>
                    <tr>
                      <td><b>Folio</b></td>
                      <td>{data.TIPO_DOCUMENTO} - {data.NUMERO_DOCUMENTO}</td>
                    </tr>
                    <tr>
                      <td><b>Fecha Documento</b></td>
                      <td>{data.FECHA_GENERACION}</td>
                    </tr>
                    <tr>
                      <td><b>Nit Emisor</b></td>
                      <td>{data.ID_EMPRESA}</td>
                    </tr>
                    <tr>
                      <td><b>Nit Receptor</b></td>
                      <td>{data.DOCUMENTO_CLIENTE}</td>
                    </tr>
                    <tr>
                      <td><b>Total a pagar</b></td>
                      <td>{data.TOTAL_VENTA}</td>
                    </tr>
                  </tbody>
                </Table>
              </Col>
            </Row>
            {this.state.exiteFact &&
              <div>
                <Row className="justify-content-md-center">
                  <Col md="auto">
                    <Button variant="primary" onClick={() => this.setState({ isAccepted: !this.state.isAccepted, isRejected: false })}>ACEPTAR</Button>
                  </Col>
                  <Col md="auto"></Col>
                  <Col md="auto">
                    <Button variant="primary" onClick={() => this.setState({ isRejected: !this.state.isRejected, isAccepted: false })} >RECHAZAR</Button>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Collapse in={this.state.isRejected}>
                      <div>
                        <Form.Group controlId="exampleForm.ControlInput1">
                          <p>
                            <Form.Label>Razon de rechazo</Form.Label>
                            <Form.Control name="causa" onChange={(e) => this.setState({ causa: e.target.value.toUpperCase() })} type="text" maxLength="500" value={this.state.causa} />
                          </p>
                          <Button id="rechazar" onClick={this.confirmar} >CONFIRMAR</Button>
                        </Form.Group>
                      </div>
                    </Collapse>
                    <Collapse in={this.state.isAccepted}>
                      <div>
                        <Form.Group controlId="exampleForm.ControlInput1">
                          <p></p>
                          <Button id="aceptar" onClick={this.confirmar}>CONFIRMAR</Button>
                        </Form.Group>
                      </div>
                    </Collapse>
                  </Col>
                </Row>
              </div>
            }
          </Container>
        </div>
      </div>
    );
  }
}
export default (Confirmacion);


// WEBPACK FOOTER //
// ./src/components/confirmacion.jsx